import { DefaultOptions } from '@tanstack/react-query';

export const defaultQueryOptions: DefaultOptions['queries'] = {
  refetchOnWindowFocus: false,
  refetchOnMount: false,
};
